import React, { Component } from "react";
import "./visitHistory.css";
import VisitHistory from "../../services/visitHistory";
import MaintenanceImage from "../../assets/images/general/maintenance_b.svg";
import Auth from "../../services/authService";
import LoadingSpinner from "../../components/loader/LoadingSpinner";
import { toast } from "react-toastify";

const user = Auth.getCurrentUser();

export default class visitHistory extends Component {

    state = {
        isLoading: false,
        VisitHistoryItems: [],
        visitHistoryCount: 0
    };

    async componentDidMount() {
        if (Auth.getCurrentUser()) {
            try {
                console.log("userId : ", user.customerid, " serial: ", this.props.serial );
                const result =
                    await VisitHistory.getUserServiceRequestItems(
                        user.customerid,
                        this.props.serial
                    );
                this.setState({ VisitHistoryItems: result.data });
                this.setState({ visitHistoryCount: result.data.length });
                const isLoading = true;
                this.setState({ isLoading });
                console.log(result);
            } catch (ex) {
                if (ex.code !== "ERR_NETWORK" && ex.code !== "ERR_BAD_REQUEST") {
                    toast.error(ex.response.data.Message);
                }
            }
        }
    }

    render() {
        return (
            <section className="container">
                <div className="row hrow headbox-dark">
                    <h3 className="title">تاریخچه پشتیبانی</h3>
                </div>
                <div className="row hrow">
                    {this.state.isLoading ? (
                        <section>

                            {this.state.visitHistoryCount == "0" &&
                                <section className="container">
                                    <div className="hrh_resultNotFound">
                                        <span>موردی برای نمایش وجود ندارد</span>
                                    </div>
                                </section>
                            }
                            {this.state.VisitHistoryItems.map((item) => (
                                <div key={item.id}>
                                    <div className="hrh_item hrh_item-gray">
                                        <img src={MaintenanceImage} alt="" />
                                        <h3 className="subject">{item.RequestType_Title}</h3>
                                        {item.ExpertMission ? (<h5>
                                            <p>نام مامور :<b>{item.ExpertMission}</b></p>
                                        </h5>) : (<p></p>)}
                                        {item.CustomerAgentName ? (<h5>
                                            <p>تحویل گیرنده:<b>{item.CustomerAgentName}</b></p>
                                        </h5>) : (<p></p>)}
                                        <p>توضیح : <b>{item.Comment}</b></p>
                                        <p>تاریخ ثبت :<b>{item.NoticeTime ? (item.NoticeDate + "ساعت : " + item.NoticeTime) : item.NoticeDate}</b></p>

                                    </div>
                                </div>
                            ))}
                        </section>
                    ) : (<LoadingSpinner />)}
                </div>
            </section>
        );
    }
}
